module.exports = __webpack_public_path__ + "static/media/img_gcxc@2x.7f0106e1.png";